import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 18 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M16.999 17v-.823c0-1.188-.66-2.286-1.728-2.876l-3.412-1.892m-5.719.001L2.728 13.3C1.659 13.892 1 14.99 1 16.179V17" }, null, -1),
    _createElementVNode("path", { d: "M9.001 12.598c-2.524 0-4.571-2.53-4.571-4.97v-2.21C4.43 2.978 6.477 1 9 1c2.525 0 4.572 1.978 4.572 4.418v2.21c0 2.44-2.047 4.97-4.572 4.97Z" }, null, -1)
  ]))]))
}
export default { render: render }